import React from "react"
import { Navigate } from "react-router-dom"





import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

import UiCards from "pages/Cards/UiCards"

import Hotel from "../pages/Reservation/hotel"

import Visa from "../pages/DemandeVisa/demandeVisa"

import UserManage from "pages/Users/user"
import BilletAvion from "pages/Reservation/billetAvion"
import VoyageOrganise from "pages/VoyageOrganise/voyageOrganise"
import Support from "pages/Support/support"
import Proprety from "pages/Proprety/proprety"
import VisaDetails from "pages/DemandeVisa/visaDetails"
import VoyageDetails from "pages/VoyageOrganise/voyageDetails"
import Dashboard from "pages/Dashboard/index"
import Profile from "pages/Dashboard/Profile"
import HotelCheckout from "pages/Reservation/hotelCheckout"
import BilletCheckout from "pages/Reservation/billetCheckout"
import { components } from "react-select"
import CreateProprety from "pages/Proprety/createProprety"
import SingleUser from "pages/Users/singleUser"

import VoyageAdd from "pages/VoyageOrganise/voyageAdd"
import Places from "pages/VoyageOrganise/places"
import Createplace from "pages/VoyageOrganise/createplace"
import Voyage from "pages/Reservation/voyage"
import Reservationvoyage from "pages/Reservation/reservationvoyage"
import PropertyDetail from "pages/Proprety/propertyDetail"
import PayementList from "pages/payement/payementList"
import CreatePayement from "pages/payement/createPayement"
import PayementDetail from "pages/payement/payementDetail"
import AdminList from "pages/Authentication/AdminList"
import CreateAdmin from "pages/Authentication/createAdmin"
import TicketDetails from "pages/Support/TicketDetails"

import Statistique  from "pages/Statistiques/statistiques"
import HotelStatistique from "pages/Statistiques/hotelStatistique"

// Root route component to handle role-based redirection
const RootRoute = () => {
  // Get the role from token/storage
  const userRole = localStorage.getItem("role");

  // If no role found, redirect to login
  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  // If moderator, redirect to support page
  if (userRole == "MODERATOR") {


    return <Navigate to="/support" replace />;
  }

  // Default redirect to Dashboard for other roles
  return <Navigate to="/Dashboard" replace />;
};



const authProtectedRoutes = [
  { path: "/Dashboard", component: <Dashboard    /> },
  { path: "/hotel", component: <Hotel    /> },
  { path: "/hotel-checkout/:id", component: < HotelCheckout/> },

  {path:"/support-tickets/:ticketId",component:<TicketDetails/>},
  { path: "/billet-avion", component: <BilletAvion /> },
  { path: "/billet-checkout/:id", component: <BilletCheckout /> },

  { path: "/visa", component: <Visa /> },

  { path: "/admins", component: <AdminList /> },
  { path: "/admins/create", component: <CreateAdmin /> },

  { path: "/voyage", component: <Voyage /> },
  { path: "/reservation/:id", component: <Reservationvoyage /> },

  { path: "/payments", component: <PayementList /> },
  { path: "/payments/:id", component: <PayementDetail /> },
  { path: "/create-payment", component: <CreatePayement /> },

  { path: "/voyage-organise", component: <VoyageOrganise /> },
  { path: "/voyage-organise/add", component: <VoyageAdd/> },
  { path: "/voyage-organise/:id", component: <VoyageDetails /> },
  { path: "/support", component: <Support /> },
  { path: "/proprety", component: <Proprety /> },
  {path : "/proprety/create",component:<CreateProprety/>},
  {path : "/properties/:id",component:<PropertyDetail/>},
  {path : "/places",component:<Places/>},
  {path : "/places/create",component:<Createplace/>},

  {path:'/statistique',component:<Statistique/> },
  {path:'/hotel-statistics',component:<HotelStatistique/>},

{path:"/user",component:<UserManage/>},
{path:"/user/:id",component:<SingleUser/>},

{ path: "/visa/:id", component: <VisaDetails /> },

{ path: "/profile", component: <Profile /> },


 
  {
    path: "/",
    exact: true,
    component: <RootRoute />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/ui", component: <UiCards /> },
  
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  
 
]

export { authProtectedRoutes, publicRoutes }
